import { atom } from "recoil"

export interface WhiteboardRoomDetails {
  roomId: string
  roomToken: string
}

export const whiteboardRoomDetailsAtom = atom<WhiteboardRoomDetails | null>({
  key: "whiteboardRoomDetailsAtom",
  default: null
})

export const whiteboardShareUserAtom = atom<WhiteboardShareuserEntity>({
  key: "whiteboardShareUserAtom",
  default: null
})

export interface WhiteboardShareuserEntity {
  uid: string
}
